import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import SquareGrid from "frontend/components/icons/SquareGrid";

import { getIconSkeletonGridContent } from "./helpers";

let SkeletonIconGrid = ({
    className,
    numberOfItems,
    numberOfColumns,
    gridSpacingSize
}) => {
    return (
        <SquareGrid
            className={className}
            gridItemContent={getIconSkeletonGridContent({ numberOfItems })}
            numberOfColumns={numberOfColumns}
            gridSpacingSize={gridSpacingSize}
        />
    );
};

SkeletonIconGrid = styled(SkeletonIconGrid)``;

SkeletonIconGrid.propTypes = {
    className: PropTypes.string,
    numberOfItems: PropTypes.number.isRequired,
    numberOfColumns: PropTypes.number.isRequired,
    gridSpacingSize: PropTypes.string
};

export default SkeletonIconGrid;
